import React from 'react';
import { Container } from '@/Components/ui/container';
import { Inline } from '@/Components/ui/layout';

function Header() {
  return (
    <header className="flex items-center justify-between gap-5 mt-5">
      <img 
        src="/Newzenalphablue.png" 
        alt="Company Logo" 
        className="w-[219px] h-auto object-contain"
      />
    </header>
  );
}

export default Header;
